// extracted by mini-css-extract-plugin
module.exports = {"root":"Cell-root-3iUnv","pressed":"Cell-pressed-1qb-_ Cell-root-3iUnv","image":"Cell-image-2S8IL","hurt":"Cell-hurt-3WVjB Cell-image-2S8IL"};